import { render } from "./DataServicesCreateView.vue?vue&type=template&id=c54b1a08"
import script from "./DataServicesCreateView.vue?vue&type=script&lang=js"
export * from "./DataServicesCreateView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__